import React, { useEffect, useState } from "react";

import SingleSelectBox from "../../../../components/FormComponents/SingleSelectBox";
import Button from "../../../../components/FormComponents/Button";
import Textarea from "../../../../components/FormComponents/Textarea";

const EditStateChangeLogic = ({ logic, selectionObj, index, changeLogic, setIsOpen, type }) => {
  const [addLogicFlag, setAddLogicFlag] = useState();

  const IDKey = type === "state" ? "state_id" : "activity_id";
  const label = type;

  const handleChangeState = (value) => {
    if (value === "") {
      setAddLogicFlag(true);
      changeLogic("condition", "true", index);
    }
    changeLogic(IDKey, value, index);
  };

  useEffect(() => {
    setAddLogicFlag(/^true$/.test(logic.condition || ""));
    if (!logic) {
      setIsOpen(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <div className="edit_activity_job">
      <div style={{ width: "100%" }}>
        <div className="builder_form">
          <SingleSelectBox
            selectedData={logic[IDKey]}
            options={Object.values(selectionObj)}
            onChange={(obj) => handleChangeState(obj.id)}
            label={`Select ${label}`}
            placeholder={`Select ${label}`}
          />
        </div>
        <div className="builder_form">
          {logic[IDKey] && addLogicFlag && (
            <>
              <label className="builder_label">Logic</label>
              <div className="builder_displayBox">
                Without logic it goes to
                <span className="highlighted_text_color"> {selectionObj[logic[IDKey]]?.name} </span>
              </div>
              <Button
                variant="secondary"
                onClick={() => {
                  setAddLogicFlag(false);
                  changeLogic("condition", "", index);
                }}
              >
                Add Logic
              </Button>
            </>
          )}

          {!addLogicFlag && (
            <Button
              variant="secondary"
              onClick={() => {
                setAddLogicFlag(true);
                changeLogic("condition", "true", index);
              }}
            >
              Remove Logic
            </Button>
          )}
        </div>

        {!addLogicFlag && (
          <div className="builder_form" style={{ width: "100%" }}>
            <label className="builder_label">Condition</label>

            <Textarea
              label="Condition"
              value={logic?.condition}
              onChange={(e) => changeLogic("condition", e.target.value, index)}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default EditStateChangeLogic;
